import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import LoadingSpinner from '../common/LoadingSpinner';

const MfaForm = ({ onSubmit, isSubmitting, hiddenEmail }) => {
  const [code, setCode] = useState('');
  const [trustDevice, setTrustDevice] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(code, trustDevice);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <p className="text-muted mb-4">
        A verification code has been sent to your email at <strong>{hiddenEmail || 'your registered email'}</strong>.
      </p>

      <Form.Group className="mb-3">
        <Form.Label htmlFor="code">Verification Code</Form.Label>
        <Form.Control
          type="password"
          id="code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          required
          autoFocus
          disabled={isSubmitting}
          placeholder="Enter the code sent to your email"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Check
          type="checkbox"
          id="trustDevice"
          label="Remember this device for 90 days"
          checked={trustDevice}
          onChange={(e) => setTrustDevice(e.target.checked)}
          disabled={isSubmitting}
        />
      </Form.Group>

      <div className="d-grid mt-4">
        <Button variant="primary" type="submit" disabled={isSubmitting}>
          {isSubmitting ? (
            <LoadingSpinner inline message="Verifying..." />
          ) : (
            'Verify'
          )}
        </Button>
      </div>
    </Form>
  );
};

export default MfaForm;
